import { OptionDto } from "@/dtos";
import { VehicleApplicationVersionStatus } from "@/helpers/types";

const vehicleApplicationVersions = [
    { value: VehicleApplicationVersionStatus.PENDING, label: 'Pendiente' },
    { value: VehicleApplicationVersionStatus.SENT, label: 'Enviado' },
] as OptionDto[];

export const getVehicleApplicationVersionOptions = (): OptionDto[] => {
    return vehicleApplicationVersions;
}

export const getVehicleApplicationVersion = (value: number): OptionDto => {
    return vehicleApplicationVersions.find((x) => x.value == value) ?? vehicleApplicationVersions[0];
}